export const TITLE_LABELS = {
	NEW_PROPERTY_TITLE: 'Create new property',
	EDIT_PROPERTY_TITLE: 'Advanced settings',
	PROPERTY_NAME_LABEL: 'Property name',
	SECTION_ARIA_LABEL: 'Set property name and mapping mode',
	SKIP_LINK_ID: 'property-name'
} as const;
